exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-section[data-v-1b6c43d7]{width:100%;height:100%;overflow:auto;border:1px solid #ccc;white-space:nowrap}.sended-list-table[data-v-1b6c43d7]{font-size:12px;width:100%}.sended-list-table[data-v-1b6c43d7]::-webkit-scrollbar{width:5px}td[data-v-1b6c43d7],th[data-v-1b6c43d7]{padding:8px}.check[data-v-1b6c43d7]{width:10%;text-align:center;vertical-align:middle}.name[data-v-1b6c43d7]{text-align:center;width:50%;vertical-align:middle}.department[data-v-1b6c43d7],.position[data-v-1b6c43d7]{text-align:center;width:20%;vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1b6c43d7","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/molecules/tables/SelectMemberTable.vue
// module id = +kbZ
// module chunks = 0